import * as wam from '@tcc/wam';

export function getUserData() {
  return wam.getUserData();
}

export function reAuthenticate() {
  return wam.reAuthenticate();
}

export function logout() {
  wam.logout();
  sessionStorage.clear();
  localStorage.clear();
}
